import { GalleryDto } from '@nusign/picflow-backend-types';
import { removeIdPrefix } from './remove-id-prefix';

export const getGalleryBackLink = (gallery: GalleryDto, isTeamMember: boolean, folderIsAlsoShared: boolean) => {
  if (gallery?.parent_gallery) {
    return `/a/gallery/${removeIdPrefix(gallery.parent_gallery as string)}`;
  }

  if (!isTeamMember && !folderIsAlsoShared) return '/a/home';

  if (gallery?.folder) return `/a/home/${gallery.folder}`;
  return '/a/home';
};
